module.exports = __webpack_public_path__ + "img/4_uk.b32dd4db.svg";